import type { GeneralConceptContent as GeneralConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptText } from "./components";

// Render the shared prose-and-example shape used by concepts that do not need a
// specialized diagram or interactive treatment.
export function GeneralConcept({
  content,
}: {
  content: GeneralConceptContentData;
}) {
  return (
    <div className="grid gap-8">
      <div className="grid items-start gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)]">
        <div className="grid gap-7">
          {content.sections.map((section) => (
            <section
              key={section.id}
              className="grid scroll-mt-20 gap-3"
              id={section.id}
            >
              <h2 className="font-semibold">{section.title}</h2>
              <div className="grid gap-4">
                {section.paragraphs.map((paragraph) => (
                  <p
                    key={paragraph}
                    className="text-muted-foreground leading-7"
                  >
                    <ConceptText text={paragraph} />
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>

        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />
      </div>

      {content.callout && (
        <div className="border-l-2 border-amber-500/60 bg-amber-50/70 px-4 py-3 dark:bg-amber-950/20">
          <p className="text-sm leading-6">
            <ConceptText text={content.callout} />
          </p>
        </div>
      )}
    </div>
  );
}
